/* eslint-disable no-param-reassign */
import { logger } from '@/plugins/logger';

const validate = (binding) => {
  if (typeof binding.value !== 'function') {
    logger.warn('[Vue-end-reached:] provided expression', binding.expression, 'is not a function.');
    return false;
  }
  return true;
};

const isServer = () => (typeof window === 'undefined');

const OPTIONS = {
  default: {
    rootMargin: '150px 0px 0px 0px',
    threshold: 0,
  },
  center: {
    rootMargin: '0px',
    threshold: 0.5,
  },
  bottom: {
    rootMargin: '0px',
    threshold: 1,
  },
};

export default {
  beforeMount(el, binding) {
    const [mod] = Object.keys(binding.modifiers);

    if (!validate(binding) || isServer()) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          el.__vueReached__.callback();

          if (binding.modifiers.once) {
            observer.unobserve(el);
          }
        }
      });
    }, OPTIONS[mod ?? 'default']);

    observer.observe(el);

    el.__vueReached__ = {
      observer,
      callback: binding.value,
    };
  },

  updated(el, binding) {
    if (validate(binding)) el.__vueReached__.callback = binding.value;
  },

  unmounted(el) {
    if (!isServer() && el.__vueReached__) {
      el.__vueReached__.observer.unobserve(el);
      delete el.__vueReached__;
    }
  },
};
